import { render } from "./ticketh.vue?vue&type=template&id=d4b5fc82"
import script from "./ticketh.vue?vue&type=script&lang=js"
export * from "./ticketh.vue?vue&type=script&lang=js"

import "./ticketh.vue?vue&type=style&index=0&id=d4b5fc82&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__